var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\u0421\u043B\u043E\u0439_1",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m111.17 68.29a14.82 14.82 0 1 0 -16.66 0 25 25 0 0 0 -7.44 4.14 35.13 35.13 0 0 0 -13.18-7.23 20.36 20.36 0 1 0 -19.77 0 35.13 35.13 0 0 0 -13.18 7.23 25 25 0 0 0 -7.44-4.14 14.83 14.83 0 1 0 -16.66 0 25.21 25.21 0 0 0 -16.84 23.71 2 2 0 0 0 4 0 21.17 21.17 0 0 1 34.05-16.76 35 35 0 0 0 -9.22 23.71 2 2 0 0 0 4 0 31.17 31.17 0 0 1 62.33 0 2 2 0 0 0 4 0 35 35 0 0 0 -9.22-23.71 21.17 21.17 0 0 1 34.06 16.76 2 2 0 0 0 4 0 25.21 25.21 0 0 0 -16.83-23.71zm-96.83-12.29a10.83 10.83 0 1 1 10.83 10.86 10.84 10.84 0 0 1 -10.83-10.86zm33.3-8.62a16.36 16.36 0 1 1 16.36 16.4 16.38 16.38 0 0 1 -16.36-16.36zm44.36 8.62a10.83 10.83 0 1 1 10.83 10.83 10.84 10.84 0 0 1 -10.83-10.83z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.356348e9db4933d1be7696686a1b587c.svg";
export { ForwardRef as ReactComponent };